<script>
import form from '@/utils/form';

import BaseSelect from '@/components/BaseSelect.vue';
import BaseInput from '@/components/BaseInput.vue';

export default {
  name: 'CompanyEmployeeForm',
  components: { BaseInput, BaseSelect },
  data() {
    return {
      id: null,
      fields: {
        role: null,
        position: null,
      },
    };
  },
  onSFinish: null,
  methods: {
    init(role, position, onFinish) {
      this.$options.onFinish = onFinish;
      if (position !== null) {
        this.fields.position = this.createPositionField();
        this.fields.position.value = position;
      }

      if (role !== null) {
        this.fields.role = this.createRoleField();
        this.fields.role.value = role;
      }
    },
    init2(item, isOwnerOrDeputy, isHead) {
      console.log(item);
      const type = item['@type'];
      if ((type === 'CompanyEmployee' || type === 'Deputy') && isOwnerOrDeputy) {
        this.fields = { position: this.createPositionField() };
        this.fields.position.value = item.position;
        return;
      }

      if (type === 'CompanyDepartmentMember' && (isOwnerOrDeputy || isHead)) {
        this.fields = {
          position: this.createPositionField(),
          role: this.createRoleField(),
        };
        this.fields.position.value = item.employee.position;
        this.fields.role.value = item.role;
      }
    },
    createRoleField() {
      return form.createFieldObject(
        'select',
        'Роль',
        'member',
        {},
        [
          { value: 'head', label: 'Руководитель отдела' },
          { value: 'manager', label: 'Менеджер' },
          { value: 'member', label: 'Сотрудник' },
        ],
      );
    },
    createPositionField() {
      return form.createFieldObject('text', 'Должность');
    },

    save() {
      const values = form.getValues(this.fields);
      // this.$emit('finish', values);
      console.log(values);
      this.$options.onFinish(values.role ?? null, values.position ?? null);
    },
    cancel() {
      this.$options.onFinish(null, null);
    },
  },
};
</script>

<template lang="pug">
  form(@submit.prevent="save" v-if="fields.role || fields.position").company-employee-form
    template(v-if="fields.role")
      .row Роль
        BaseSelect(v-model="fields.role.value" v-bind="fields.role" hideNotSelected)
    template(v-if="fields.position")
      .row Должность
        BaseInput(v-model="fields.position.value" v-bind="fields.position")
    .buttons
      Btn(@click="cancel" grey) Отмена
      Btn(@click="save") Сохранить
</template>

<style scoped lang="scss">

.company-employee-form {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  gap: 15px;
  font-size: 14px;
  color: #1E3147;
}

.buttons {
  display: flex;
  gap: 20px;
  margin-top: 15px;
  justify-content: flex-end;
}
</style>
